module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "speakers columns is-multiline"
  }, _vm._l((_vm.speakersObject), function(speaker) {
    return _c('div', {
      staticClass: "speaker-wrapper column is-one-third"
    }, [_c('Speaker', {
      attrs: {
        "speaker": speaker
      },
      on: {
        "speaker-saved": _vm.reloadSpeakers
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "centered add-speaker"
  }, [_c('a', {
    staticClass: "button is-info",
    on: {
      "click": _vm.handleAddSpeaker
    }
  }, [_vm._v("+ Добавить спикера")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e107ad50"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events/Speakers.vue
// module id = 1007
// module chunks = 0